import $ from 'jquery'
import mixitup from 'mixitup';

import 'semantic-ui-transition/transition.css'
import 'semantic-ui-dropdown/dropdown.css'

export default function initMix() {
	$.fn.transition = require("semantic-ui-transition");
	$.fn.dropdown = require('semantic-ui-dropdown');

	var $filterSelect = $('#FilterSelect'),
	    // $sortSelect = $('#SortSelect'),
	    $container = $('.testing-mix');
	
	// $container.mixItUp();
	var mixer = mixitup('.js-mix-container');

	if($('.ui.dropdown')) {
	  $('.ui.dropdown').dropdown({
	  	onChange: function(text, value) {
  	      // $container.mixItUp('filter', value)
  	      // mixer.filter('.category-a')
  	      if(text === 'all') {
  	      	mixer.show().then((state) => {
  	      		console.log(state.totalShow)
  	      	})
  	      }
  	      console.log(value, text);
  	      mixer.filter(text).then((state) => {
  	      	console.log(state.totalShow)
  	      });
  	    }
	  });
	}
}


// WEBPACK FOOTER //
// ./src/js/initMix.js